import { FC } from "react";
import { useSelector } from "react-redux";

import { SettingsTable as Table } from "components/settings-table";
import { selectDomains } from "store/entities/email-domains";

import { DomainSetupAction } from "../DomainSetupModal";

import { DomainListEntry } from "./DomainListEntry";

interface IDomainsListProps {
  setModalAction: (action: DomainSetupAction | null) => void;
  openDeleteModal: (domainId: string) => void;
  canManageDomains: boolean;
}

export const DomainsList: FC<IDomainsListProps> = ({ setModalAction, openDeleteModal, canManageDomains }) => {
  const domains = useSelector(selectDomains);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const validDomains = domains.filter((domain: any) => domain.domain);

  return (
    <Table columns={2} marginTop="0" columnSizes="7fr 4fr" headers={["Domain", "Status"]}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {validDomains.map((domain: any) => (
        <DomainListEntry
          key={domain.id}
          domain={domain}
          setModalAction={setModalAction}
          openDeleteModal={openDeleteModal}
          canManageDomains={canManageDomains}
        />
      ))}
    </Table>
  );
};
